// extracted by mini-css-extract-plugin
module.exports = {"main_container":"AssetTypeDetailPage_main_container__2APfk","red_text":"AssetTypeDetailPage_red_text__3y5-e","delete_buttons":"AssetTypeDetailPage_delete_buttons__t1eV6"};